import { useCallback, useMemo } from "react";
import { useConditional } from "../state/storeConditional ";

// Static data for month names and list
const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const MONTH_LIST = {value:[
  { name: 'January', method: '1' },
  { name: 'February', method: '2' },
  { name: 'March', method: '3' },
  { name: 'April', method: '4' },
  { name: 'May', method: '5' },
  { name: 'June', method: '6' },
  { name: 'July', method: '7' },
  { name: 'August', method: '8' },
  { name: 'September', method: '9' },
  { name: 'October', method: '10' },
  { name: 'November', method: '11' },
  { name: 'December', method: '12' },
  { name: 'Ramadan', method: '13' },
]};

export const useMonth = () => {
  const { isRamadan } = useConditional();

  // Memoize the MonthName function to avoid recreating it on every render
  const MonthName = useCallback((month: number) => {
    return MONTH_NAMES[month];
  }, []);

  // Memoize the MonthList function to avoid recalculating it on every render
  const MonthList = useMemo(() => {
    return MONTH_LIST.value.filter((item) => 
      !isRamadan.ramadan ? item.name !== 'Ramadan' : true
    );
  }, [isRamadan.ramadan]);

  return { MonthName, MonthList };
};